import React from "react";

const Plus = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <rect
        x="5.83203"
        width="2.33333"
        height="14"
        rx="1.16667"
        fill="#D91D1E"
      />
      <rect
        x="14"
        y="5.83594"
        width="2.33333"
        height="14"
        rx="1.16667"
        transform="rotate(90 14 5.83594)"
        fill="#D91D1E"
      />
    </svg>
  );
};

export default Plus;
